///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { usersListFeatureKey, UsersListState } from './users-list.state';
import { PagedModel } from '../../generated/spring-types.model';
import { GtthKeyValueDTO, UserActivityEventDTO } from '../../generated/shared-types.model';
import { SuiUserDTO } from '../../generated/shared-sui-types.model';

export const selectUsersListState = createFeatureSelector<UsersListState>(usersListFeatureKey);

export const selectUsersPage = createSelector(
    selectUsersListState,
    (usersListState: UsersListState): PagedModel<SuiUserDTO> => usersListState.usersPage
);

export const selectUserActivityEvents = createSelector(
    selectUsersListState,
    (usersListState: UsersListState): PagedModel<UserActivityEventDTO> => usersListState.selectedUserActivityEventsPage
);

export const selectUserActivityEventTypes = createSelector(
    selectUsersListState,
    (usersListState: UsersListState): GtthKeyValueDTO[] => usersListState.userEventTypes
);

export const selectShowEditButtonPermission = createSelector(
    selectUsersListState,
    (usersListState: UsersListState): boolean => usersListState.showEditButton
);

export const selectCurrentAccount = createSelector(
    selectUsersListState,
    (usersListState: UsersListState): SuiUserDTO => usersListState.currentAccount
);

export const selectUsersList = createSelector(
    selectUsersListState,
    (usersListState: UsersListState): SuiUserDTO[] => usersListState.usersList
);

export const selectTotalItems = createSelector(selectUsersListState, (usersListState: UsersListState): number => usersListState.totalItems);

export const selectPageNumber = createSelector(selectUsersListState, (usersListState: UsersListState): number => usersListState.pageNumber);

export const selectPageCount = createSelector(selectUsersListState, (usersListState: UsersListState): number => usersListState.totalPages);
